import { getArticles } from '/src/main.js';

export const prerender = true;

export async function load({ params }) {
	const articles = await getArticles()

	if (articles && articles.length > 0) {
		return {
			articles: articles
		}
	} else {
		return {
			articles: []
		}
	}
}